import {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {IDetailTransaction} from "../../utils/interfaces/IDetailTransaction";
import {IRebound} from "../../utils/interfaces/IRebound";
import DetailsReboundRow from "./DetailsReboundRow";
import {IDetailRebound} from "../../utils/interfaces/IDetailRebound";
import {modalVariants} from "./ui/ModalVariant";
import MonthlyInvoiceForm from "./MontlyInvoices/MonthlyInvoiceForm";
import DetailsTransactionList from "./DetailsTransactionList";


interface Props {
    obj: IRebound,
}

function DetailsReboundList({obj: initialObj}: Props) {
    const [obj, setObj] = useState<IRebound>(initialObj)

    const mapped_objs = obj?.details.map((obj: IDetailRebound, index) => (
        <motion.tr
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.5}}
            // className={obj.type === 'refund' ? 'bg-mcia_accounting_refund' : obj.type === 'rebound' ? 'bg-mcia_accounting_rebound' : ''}
        >
            <DetailsReboundRow obj={obj}/>
        </motion.tr>
    ));

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <motion.table
                className="bg-mcia_gray_soft shadow-xl rounded-lg p-4 mb-4 w-[500px] relative"
                initial={{x: '100%'}}
                animate={{x: '0%'}}
                transition={{duration: 0.2}}
            >

                <thead className='mycia_thead'>
                <tr className='mb-0.5'>
                    <th className="cisco_th rounded-tl">
                        <span className="mr-2">Rebound</span>
                        <span className="mr-8">Id</span>
                    </th>
                    <th className="cisco_th">
                        <span className="mr-2">Date</span>
                        <span className="mr-8"></span>
                    </th>
                    <th className="cisco_th ">
                        <span className="mr-12">To be </span>
                        <span className="mr-1">Invoiced</span>
                        <span className="mr-8"></span>
                    </th>
                    <th className="cisco_th "
                    >
                        <span className="mr-1">Ordini</span>
                        {/*<span className="mr-8"></span>*/}
                    </th>
                    <th className="cisco_th "
                    >
                        <span className="mr-1"></span>
                        <span className="mr-8"></span>
                    </th>

                </tr>
                </thead>
                <tbody>
                {mapped_objs}
                </tbody>
            </motion.table>


        </>
    )
}

export default DetailsReboundList;